import { render, staticRenderFns } from "./WaybillCostDetails.vue?vue&type=template&id=6666b3fc&scoped=true&"
import script from "./WaybillCostDetails.vue?vue&type=script&lang=js&"
export * from "./WaybillCostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666b3fc",
  null
  
)

export default component.exports